import { useEffect, useState } from "react";
import './meetinginfo.css'
import { AiOutlineClose } from "react-icons/ai";
import TimeFormatter from "../../utility/TimeFormatter";
import GetImage from "../../components/getimage/Getimage";
import flagicon from "../../assets/flag_icon-transformed.png"
import Myedit from "../../assets/edit-transformed.png"
import mydeleteinfo from "../../assets/delete-transformed.png"
import "../../pages/Ticketdiv/components/subcomps/ticketinfo.css"
import { TicketScore } from "../../components/ticketscore/Ticketscore";
import getMeetingTime from "./utility/getMeetingTime";
import GetHrsTime from "../../utility/GetHrsTime";
import { FaMicrophoneLines } from "react-icons/fa6";
import { showConfirm } from "../../utility/showconfirm";
import Loader from "../../components/loader/Loader";
import Hexapi from "../../utility/HexAPI/Hexapi";
import { Modal } from "react-bootstrap";
import meeticon from "../../assets/meet_icon.png"
import CustomSocial from "../../components/customsocial/Customsocial";
import { BsShareFill } from "react-icons/bs";
import Editmeeting from "./addmeeting/Editmeeting";
const Meetinginfo = ({ info,isAttendee,setisInfo,userid ,getMeetingListData ,GetMeetingDetails}) => {

 const [dataSet, setDataSet] = useState(null);
 const [loading, setLoading] = useState(false);
 const[refershow,setrefershow] =useState(false)
 const [show,setshow]=useState(false)
 const getData=()=>{
    const data=info
    const ids = data.empids.split(",");
const names = data.empnames.split(",");
const actions = data.emprsvpactions.split("$#12$$");
const logTimes = data.emprsvplogtime.split("$#12$$");
const remarks = data.emprsvpremarks.split("$#12$$");
const presents = data.presents.split(",");
const scores = data.scores.split(",");

const datasetAll = ids.map((id, index) => ({
  empid: Number(id),
  empname: names[index],
  rsvpaction: Number(actions[index]),
  rsvplogtime: logTimes[index],
  rsvpremarks: remarks[index] === "-1" || remarks[index] == "" ? null : remarks[index],
  present: Number(presents[index]),
  score: Number(scores[index])
}));

setDataSet(datasetAll);

  }

  const handleDeleteMeeting = async () => {
 const result = await showConfirm({
  content:"Are you sure you want to cancel this meeting?",
  okText:"Yes",
  cancelText:"No",
  hideCancel:false
 })
 if (!result) return;
  try {

    setLoading(true);

    const obj = {
      query: "HRApp_Droid_Proc_User_Meeting_Cancel @UserID='{0}' , @MeetingID='{1}'",
      queryArr: [`${userid}`, `${info?.meetingid}`]
    };

    const res = await Hexapi(obj);
console.log(res,"res")
if(res && res[""] && res[""][0]){
  if(res[""][0].command == 1){
showConfirm({
  content:res[""][0].msg,
  hideCancel:true
}).then(()=>{
  getMeetingListData()
})
  }else{
showConfirm({
  content:res[""][0].msg,
  hideCancel:true
})
  }
}

  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};
  const rsvpaction = (rsvp,rsvplogtime)=>{
    let str =""

    if(rsvp == 1){
      const data =TimeFormatter(rsvplogtime)

      str = `RSVP'd Yes at ${data.ShiftTime} , ${data?.ShiftDate.split("-")[2]} ${data.shiftFullMonth}`
    }else if(rsvp == -1){
      const data =TimeFormatter(rsvplogtime)

      str = `RSVP'd No at ${data.ShiftTime} , ${data?.ShiftDate.split("-")[2]} ${data.shiftFullMonth}`
    }else{
      str = "RSVP Pending"
    }
    return str;
  }
  useEffect(()=>{
    if(isAttendee && isAttendee.length > 0){
      getData()
    }
  },[isAttendee])
  let createdtime=""
  let time = TimeFormatter(info?.createdtime?.date)
            createdtime = `Created by ${info?.createdbyempname} on ${time.ShiftTime}, ${time.userSplitedDate[2]} ${time.fullMonthName}`

   let startdate = `${getMeetingTime(info?.scheduledtime?.date)} , ${time.userSplitedDate[2]} ${time.fullMonthName} ${GetHrsTime(info?.duration)}`

  return (
    <div className="infosetmain">
      {loading && <Modal centered show={loading}>
        <Modal.Body>
          <Loader />
        </Modal.Body>
        </Modal>}
<div className="infohead">
  <div className="editdeletesec">
<p style={{fontWeight:"600",marginBottom:"0px"}}>Meeting Info</p>
{info?.allowdelete == 1 ?
     <div className='mydeleteinfo' onClick={()=>handleDeleteMeeting()} >
    <img src={mydeleteinfo} className=' img-fluid wid-img-1 cur-point white-icon'  />
      </div>
       : null}

{ info?.allowedit == 1  ?  <div className='myedit cur-point' onClick={()=>setshow(true)} >
     <img src={Myedit} className='img-fluid wid-img-1' />
      </div>: null
}

  </div>
<div>
  <p style={{marginBottom:"0px" , cursor:"pointer"}} onClick={()=>setisInfo(false)}><AiOutlineClose /></p>
</div>
</div>

<div className="desmeeting" style={{color:"#2f2c2c"}}>
  <p style={{marginBottom:"0px",marginTop:"10px"}}>{startdate}</p>
  <p style={{marginBottom:"0px"}}>{createdtime}</p>
</div>
<div className="desmeeting">
  <p style={{fontWeight:"600",marginBottom:"0px" , color:"#29b6f6",marginTop:"10px"}}>Description</p>
  <p style={{marginBottom:"0px"}}>{info?.description || "No description available"}</p>
</div>
{
  info?.meetlink !=-1 && <div className="desmeeting">
  <p style={{fontWeight:"600",marginBottom:"0px" , color:"#29b6f6" ,marginTop:"10px"}}>Google Meet Link</p>
  <div style={{display:"flex" , justifyContent:"space-between" , alignItems:"center"}}>
  <p style={{marginBottom:"0px" , whiteSpace:"pre-wrap" , wordBreak:"break-word"}}>{info?.meetlink}</p>
  <div style={{display:"flex" , gap:"10px" , alignItems:"center"}} >
    <img src={meeticon} style={{width:"20px" , height:"20px", cursor:"pointer"}}  onClick={(e) => {
      e.stopPropagation();
      window.open(info?.meetlink, "_blank"); 
    }}
     onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
    />
 <p  className='iconcss' onClick={() => setrefershow(true)}>
                      <BsShareFill style={{fontSize:"14px",}} />
                    </p>
    </div>
    </div>
</div>
}

<div className="desmeeting">
  <p style={{fontWeight:"600",marginBottom:"0px" , color:"#29b6f6" ,marginTop:"10px"}}>Location</p>
  <p style={{marginBottom:"0px"}}>{info?.location}</p>
</div>


{dataSet && dataSet.length > 0 ? <div>
  <p  style={{fontWeight:"600",marginBottom:"0px" ,color:"#29b6f6" , marginTop:"10px"}}>Participants</p>
  <div style={{display:"flex", flexDirection:"column", gap:"10px"}}>

    {dataSet.map((item, index) => (
      <div key={index} style={{display:"flex", justifyContent:"space-between", padding:"5px 0"}}>
        <div style={{display:"flex" , gap:"10px", alignItems:"center"}}>
            <div
    style={{
      border: item.present == 1 ? "3px solid green" : "",
      borderRadius: "50%",
      padding: "2px"
    }}
  >
          <GetImage imgID={item.empid} width="40px" height="40px" />
        </div>
        <div>
        <p style={{marginBottom:"0px"}}>{item?.empname}</p>
        <p  style={{fontSize:"12px", marginBottom:"0px",color:item.rsvpaction == 1 ? "green" : item.rsvpaction == -1 ? "red" : "gray"}}>{rsvpaction(item.rsvpaction,item.rsvplogtime)}</p>
          </div>
          </div>
          <div style={{display:"flex",alignItems:"center"}}>
            {
              item?.empid == info?.hostempid &&  <div style={{color:"red", fontSize:"22px"}}>
             <FaMicrophoneLines />
              </div>
            }

             <div>
            <TicketScore kpiscore={item?.score}/>
            </div>
            {
              (info?.allowredflag == 1 && item.empid != userid)  &&
              <img src={flagicon} className="img-fluid" style={{width:"40px"}}/>
            }
       <div>

        </div>
            </div>

      </div>
    ))}
  </div>
</div> : <p>No participants data available</p>
}

 { (info?.meetlink !=-1 && refershow) &&
      <CustomSocial ismeet={true} show={refershow} hide={() => setrefershow(false)} data={{sharemsg:info?.meetlink}} />
    }
    {
      <Editmeeting GetMeetingDetails={GetMeetingDetails} getMeetingListData={getMeetingListData} meetingid={info?.meetingid} show={show} hide={()=>setshow(false)}/>
    }
    </div>
  );
};

export default Meetinginfo;